import { combineReducers } from "redux";
import AuthReducer from "./auth.reducer";
import DashReducer from "./dashboard.reducer";

export default combineReducers({
	auth: AuthReducer,
	dash: DashReducer
});
